var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rateios',{directives:[{name:"show",rawName:"v-show",value:(_vm.mostrarContratacaoRateios),expression:"mostrarContratacaoRateios"}],attrs:{"contratacaoRateios":_vm.contratacaoRateios,"dotacoesServicos":_vm.obterServicos()},on:{"atualizarContratacaoRateios":function($event){_vm.contratacaoRateios = $event}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }